export const fillPrnTemplate = (prnCode, item) => {
  let output = String(prnCode || "");

  const safeItem = {
    ...item,
    ItemCode: item?.itemCode ?? item?.ItemCode ?? "",
    ProductCode: item?.productCode ?? item?.ProductCode ?? "",
    ProductName: item?.productName ?? item?.ProductName ?? "",
    CategoryName: item?.categoryName ?? item?.CategoryName ?? "",
    DesignName: item?.designName ?? item?.DesignName ?? "",
    PurityName: item?.purityName ?? item?.PurityName ?? "",
    GrossWt: item?.grossWt ?? item?.GrossWt ?? "",
    NetWt: item?.netWt ?? item?.NetWt ?? "",
    TotalWt: item?.totalWt ?? item?.TotalWt ?? "",
    MRP: item?.mrp ?? item?.MRP ?? "",
    RFIDCode: item?.rfidCode ?? item?.RFIDCode ?? "",
    EPCCode: item?.epcCode ?? item?.EPCCode ?? "",
  };

  // ${FieldName}
  output = output.replace(/\$\{(.*?)\}/g, (_, key) => {
    const field = String(key || "").trim();
    const value = safeItem?.[field];
    return value == null ? "" : String(value);
  });

  // {{FieldName}}
  output = output.replace(/\{\{(.*?)\}\}/g, (_, key) => {
    const field = String(key || "").trim();
    const value = safeItem?.[field];
    return value == null ? "" : String(value);
  });

  return output;
};